import { render } from "./Programas.vue?vue&type=template&id=877918c8"
import script from "./Programas.vue?vue&type=script&lang=js"
export * from "./Programas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__